var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_1054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4576 120C38.6949 120 21 93.0915 21 60C21 26.9085 38.6949 0 60.4576 0C82.2203 0 99.9153 26.9085 99.9153 60C99.9153 93.0915 82.2203 120 60.4576 120ZM60.4576 2.0339C39.8136 2.0339 23.0339 28.0475 23.0339 60C23.0339 91.9525 39.8136 117.966 60.4576 117.966C81.1017 117.966 97.8814 91.9525 97.8814 60C97.8814 28.0475 81.1017 2.0339 60.4576 2.0339Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6283 101.39H72.052V100.373H87.6113V75.6611H88.6283V101.39Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6283 44.3388H87.6113V19.627H72.052V18.61H88.6283V44.3388Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8855 119.247L60.0312 118.719L71.5838 100.678L81.4889 59.9999L71.5838 19.3219L60.0312 1.30158L60.8855 0.732086L72.5397 18.9965L82.5465 59.9999L82.5058 60.1219L72.4787 101.146L60.8855 119.247Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4699 60.2849L87.7513 44.7052L59.5208 26.6442L71.6224 18.773L76.2597 6.52896L77.2157 6.89506L72.4563 19.4442L72.314 19.5459L61.3919 26.6442L88.5445 44.0544L99.3241 59.7154L98.4699 60.2849Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2597 113.471L71.6428 101.227L59.5208 93.5592L87.7513 75.2948L98.4699 59.7152L99.3241 60.2847L88.4021 76.0881L61.3919 93.5592L72.4563 100.536L72.5174 100.698L77.2157 113.105L76.2597 113.471Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3208 44.8068L87.9141 43.8712L96.4564 40.0068L96.8632 40.9424L88.3208 44.8068Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4564 79.9934L87.9141 76.129L88.3208 75.1934L96.8632 79.0578L96.4564 79.9934Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8653 101.39H32.2891V75.6611H33.306V100.373H48.8653V101.39Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.306 44.3388H32.2891V18.61H48.8653V19.627H33.306V44.3388Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0304 119.247L48.3762 101.003L38.3694 60L38.4101 59.878L48.4372 18.8542L60.0304 0.732208L60.8846 1.3017L49.3321 19.322L39.427 60L49.3321 100.678L60.8846 118.719L60.0304 119.247Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4429 60.2849L21.5886 59.7154L32.531 43.912L59.5208 26.6442L48.4564 19.4646L43.514 6.89506L44.4496 6.52896L49.27 18.773L61.392 26.6442L33.1615 44.7052L22.4429 60.2849Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4496 113.471L43.514 113.105L48.4564 100.536L48.5988 100.454L59.5208 93.5592L32.3683 75.9457L21.5886 60.2847L22.4429 59.7152L33.1615 75.2948L61.392 93.5592L49.27 101.227L44.4496 113.471Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4763 40.02L24.0571 40.9465L32.6 44.811L33.0191 43.8844L24.4763 40.02Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5882 75.1869L24.0466 79.0543L24.4661 79.9807L33.0076 76.1133L32.5882 75.1869Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_1054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.9153,
    height: 120,
    fill: "white",
    transform: "translate(21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/Oval.855e7e6e3220421ab19e886bf3413393.svg";
export { ForwardRef as ReactComponent };